export default "__VITE_ASSET__CiUnSE8M__"